module.exports = "https://referendum2020-campaigns-cdn.fire-emblem-heroes.com/images/219.59542752.png";